export default __webpack_public_path__ + "static/media/solid.c896b01e.svg";